import { render, staticRenderFns } from "./exclamation-circled.vue?vue&type=template&id=13ea0a4c&"
import script from "./exclamation-circled.vue?vue&type=script&lang=js&"
export * from "./exclamation-circled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports